export const SET_USER = 'setUser'
export const SET_USERS = 'setUsers'
export const USER_RESET = 'userReset'
export const USER_RESET_STATE = 'userResetState'
export const SET_PERMISSIONS = 'setPermissions'
export const SET_LEVELS = 'setLevels'
export const UPDATE_PERMISSION = 'updatePermission'
export const SET_USER_PAGINATION = 'setUserPagination'
export const SET_USER_ACTIVE = 'setUserActive'